module.exports = __webpack_public_path__ + "img/Broken_Spearpoint.d47b60d9.png";